import picBinamarga from '../images/project/binamarga.jpg'
import picKeramik from '../images/project/keramik.jpg'
import picKonsultasi from '../images/project/klinikkonsultasi.jpg'
import picSic from '../images/project/sic.jpg'
import picSimpeg from '../images/project/simpeg.jpg'
import picWasuponda from '../images/project/wasuponda.jpg'

import ps1img2 from '../images/project-single/img-2.jpg'
import ps1img3 from '../images/project-single/img-3.jpg'

import psub1img1 from '../images/project-single/p1.jpg'
import psub1img2 from '../images/project-single/p2.jpg'

// import sicPlayStore from '../images/sic/playstore.jpg'
import sicBanner from '../images/sic/banner.jpg'
import sicSS1 from '../images/sic/ss1.png'
import sicSS2 from '../images/sic/ss2.png'


const Projects = [
   {
      Id: '1',
      pImg: picSic,
      ps1img: sicBanner,
      psub1img1: sicSS1,
      psub1img2: sicSS2,
      title: 'SIC - Employee Information Application',
      subTitle: 'Mobile Apps, Flutter, Python',
      goals: [
         'Build mobile app that able to display employee information and log attendance of employee based on office location and employee face'
      ],
      solutions: [
         'Design and develop mobile app used for showing information about employee profile and information. The main feature is "Online Attendance Logging" that log all employee presence at office on working time. The attendance system use face recognition and location based restriction. I use Flutter to build the mobile app whereas the backend is build with Python using Django and Django Rest Framework connected with PostgreSQL. This mobile app named with SIC. The apps also connected with other system named Employee Management System (SIMPEG/ Sistem Informasi Kepegawaian) that I developed before using Svelte JS and Django.'
      ],
      location: "Sumenep",
      client: "BKPSDM Sumenep",
      consult: "-",
      type: "Mobile",
      duration: "Lifetime",
      completion: "~",
      share: "Play Store, App Store"
   },
   {
      Id: '2',
      pImg: picSimpeg,
      ps1img: picSimpeg,
      psub1img1: picSimpeg,
      psub1img2: picSimpeg,
      title: 'SIMPEG - Employee Management System',
      subTitle: 'Web, Python, Svelte',
      goals: [
         'The government need an application which will be used to manage all information about employee works on the office. The application must easy to use and can be integrated with any other system that need employee information'
      ],
      solutions: [
         'I develop the application to manage employee information using Django and Django Rest Framework for backend service and Svelte JS for the frontend.',
         'The data from backend distributed to other system needed employe data through REST API service provided from Django Rest Framework',
         'All the data used in this application stored in PostgreSQL'
      ],
      location: "Sumenep",
      client: "BKPSDM Sumenep",
      consult: "-",
      type: "Web",
      duration: "Lifetime",
      completion: "~",
      share: "website"
   },
   {
      Id: '3',
      pImg: picKonsultasi,
      ps1img: picKonsultasi,
      psub1img1: picKonsultasi,
      psub1img2: picKonsultasi,
      title: 'Klinik Konsultasi - Government Consultation Application',
      subTitle: 'Web, Mobile, Flutter, Svelte, Python',
      goals: [
         'Inspektorat of Sumenep Government need an application to serve employee consultation about governmental problem that need more information to be explained'
      ],
      solutions: [
         'I build mobile apps called Klinik Konsultasi that will serve employee if they need to consult about their problem with Inspektorat of Sumenep Goverment'
      ],
      location: "Sumenep",
      client: "Inspektorat Sumenep",
      consult: "Affan",
      type: "Mobile, Web",
      duration: "4 Month",
      completion: "December 2021",
      share: "Play Store, website"
   },
   {
      Id: '4',
      pImg: picWasuponda,
      ps1img: picWasuponda,
      psub1img1: psub1img1,
      psub1img2: psub1img2,
      title: 'Visit Wasuponda - Tourism Information Website',
      subTitle: 'HTML, CSS, JavaScript',
      goals: [
         'Need web profile'
      ],
      solutions: [
         'Build web profile using HTML, CSS and Javascript'
      ],
      location: "Sumenep",
      client: "Malang Collage Student",
      consult: "Affan",
      type: "Web",
      duration: "1 Week",
      completion: "Juni 2022",
      share: "website"
   },
   {
      Id: '5',
      pImg: picBinamarga,
      ps1img: picBinamarga,
      psub1img1: psub1img1,
      psub1img2: psub1img2,
      title: 'Web Profile - Home Page for Dinas Pekerjaan Umum Bina Marga',
      subTitle: 'PHP, CodeIgniter',
      goals: [
         'Need website to pusblish all information about the instance'
      ],
      solutions: [
         'Web profile using PHP and CodeIgniter Framework with MySQL as RDBMS'
      ],
      location: "Sumenep",
      client: "Bina Marga Sumenep",
      consult: "Affan",
      type: "Web",
      duration: "1 Month",
      completion: "September 2019",
      share: "website (not active for now)"
   },
   {
      Id: '6',
      pImg: picKeramik,
      ps1img: picKeramik,
      psub1img1: picKeramik,
      psub1img2: picKeramik,
      title: 'Kampoeng Keramik Dinoyo - Tourism Information Website',
      subTitle: 'HTML, CSS, JavaScript',
      goals: [
         'Need web profile'
      ],
      solutions: [
         'Build web profile using HTML, CSS and Javascript'
      ],
      location: "Sumenep",
      client: "Malang Collage Student",
      consult: "Affan",
      type: "Web",
      duration: "1 Week",
      completion: "Juli 2022",
      share: "website"
   },

]

export default Projects;